<script setup>
defineProps({
  compareField: {
    type: Object,
    default: null,
  },
  hasBodyShadow: {
    type: Boolean,
    default: false,
  },
  isSkeleton: {
    type: Boolean,
    default: false,
  },
  location: {
    type: Object,
    required: true,
  },
  range: {
    type: Object,
    default: null,
  },
  showCloseButton: {
    type: Boolean,
    default: false,
  },
});

defineEmits(['close-button-click', 'show-add-favorites-dialog']);

const snowReportSummaryClass = [
  'tw-w-1/3 lg:tw-w-1/5',
  'tw-pt-4 lg:tw-pt-8 tw-pr-1 lg:tw-px-3.5',
  'tw-mr-1 lg:tw-mr-3.5',
  'tw-border-r border-color',
];
</script>

<template>
  <Card
    :has-body-padding-small="true"
    :has-body-shadow="hasBodyShadow"
    :show-close-button="showCloseButton"
    @close-button-click="$emit('close-button-click')"
  >
    <template #body>
      <SnowLocationHeader
        :compare-field="compareField"
        :is-skeleton="isSkeleton"
        :location="location"
      />
      <div class="tw-flex tw-mt-2.5">
        <SnowReportSummary
          :container-class="snowReportSummaryClass"
          :is-skeleton="isSkeleton"
          :location="location"
        />
        <Snow10DayForecastSummary
          container-class="tw-w-2/3 lg:tw-w-4/5"
          :location="location"
          :is-skeleton="isSkeleton"
          :range="range"
        />
      </div>
      <AddFavoriteLocationFooter
        v-if="isSkeleton"
        @show-add-favorites-dialog="$emit('show-add-favorites-dialog')"
      />
      <SnowLocationFooter
        v-else
        class="tw-mt-1 lg:tw-mt-2"
        :location="location"
        view-type="newSnow"
      />
    </template>
  </Card>
</template>
